module.exports = __webpack_public_path__ + "img/wesoft_1.3e6b2146.png";